module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"tooltip":"Zestawienie prezentuje przegląd aktualnej dostępności w sklepach oraz dodatkowo listę niedostępnych produktów."}}')
  delete Component.options._Ctor
}
